(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-nrp-product]').forEach((el) => {
      if (el.dataset.ready) return;
      el.dataset.ready = 'true';
      const form = el.querySelector('form');
      const select = form.querySelector('[name="id"]');
      const payload = { add: el.dataset.add, sold: el.dataset.sold, variants: [...select.options].map(o => ({ id: o.value, title: o.dataset.title, money: o.dataset.money, available: o.dataset.available === 'true', min: Number(o.dataset.min) || 1, max: Number(o.dataset.max) || null, increment: Number(o.dataset.increment) || 1, image: o.dataset.image })) };
      const qty = form.querySelector('[name="quantity"]');
      const atc = form.querySelector('[type="submit"]');
      const price = el.querySelector('[data-nrp-price]');
      const color = el.querySelector('[data-nrp-color]');
      const hero = el.querySelector('[data-nrp-hero]');
      const buttons = [...el.querySelectorAll('[data-nrp-variant]')];
      const thumbs = [...el.querySelectorAll('[data-nrp-thumb]')];
      const setImage = (src, alt = '', thumb = null) => {
        if (!src || !hero) return;
        hero.src = src;
        hero.removeAttribute('srcset');
        hero.alt = alt;
        thumbs.forEach(t => t.setAttribute('aria-current', t === thumb ? 'true' : 'false'));
      };
      const setVariant = (id, updateImage = true) => {
        const v = payload.variants.find(v => String(v.id) === String(id));
        if (!v) return;
        select.value = String(v.id);
        buttons.forEach(b => b.setAttribute('aria-pressed', b.dataset.nrpVariant === String(v.id) ? 'true' : 'false'));
        price.textContent = v.money;
        color.textContent = v.title;
        atc.disabled = !v.available;
        atc.textContent = v.available ? payload.add : payload.sold;
        qty.min = String(v.min);
        qty.step = String(v.increment);
        if (v.max) qty.max = String(v.max); else qty.removeAttribute('max');
        qty.value = String(v.min);
        if (updateImage && v.image) setImage(v.image, v.title);
        const url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url);
      };
      buttons.forEach(b => b.addEventListener('click', () => setVariant(b.dataset.nrpVariant)));
      select.addEventListener('change', () => setVariant(select.value));
      thumbs.forEach(t => t.addEventListener('click', () => setImage(t.dataset.src, t.dataset.alt || '', t)));
      el.querySelectorAll('[data-nrp-quantity]').forEach(b => b.addEventListener('click', () => {
        if (b.dataset.nrpQuantity === 'minus') qty.stepDown(); else qty.stepUp();
        qty.dispatchEvent(new Event('change', { bubbles: true }));
      }));
      el.classList.add('nrp-ready');
      const selected = payload.variants.find(v => String(v.id) === select.value);
      if (selected) {
        buttons.forEach(b => b.setAttribute('aria-pressed', b.dataset.nrpVariant === String(selected.id) ? 'true' : 'false'));
        const url = new URL(location.href);
        if (url.searchParams.has('variant')) setVariant(selected.id);
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', e => init(e.target.parentElement || document));
})();
